/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useRef,
  useEffect,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { Form } from '@unform/web';
import * as yup from 'yup';
import { FormHandles } from '@unform/core';
import DepartamentosService from '../../../../services/departamentos';
import Select from '../../../../components/Select';
import InputCurrency from '../../../../components/InputCurrency';
import getValidationErrors from '../../../../utils/getValidationErrors';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import TableLoader from '../../../../components/TableLoader';
import { Container } from './styles';

interface CreateOrderByValueModalProps {
  show: boolean;
  title: string;
  handleClose(): void;
  handleAdd(data: any): void;
}

const schema = yup.object().shape({
  // departamento: yup.string().required('Departamento é obrigatório'),
  // valor: yup.string().required('Valor é obrigatório'),
});

const CreateOrderByValueModal: React.FC<CreateOrderByValueModalProps> = ({
  handleClose,
  handleAdd,
  show,
  title,
}) => {
  const formTableRef = useRef<FormHandles>(null);
  const services = { DepartamentosService: new DepartamentosService() };
  const [loading, setLoading] = useState<boolean>(false);
  const [departamentos, setDepartamentos] = useState<any>([]);

  const handleGetDepartamentos = useCallback(async () => {
    try {
      const response = await services.DepartamentosService.getDepartamentos();
      setDepartamentos(response.data.DepartamentoLista);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const handleSubmit = useCallback(async (data: any) => {
    try {
      formTableRef.current?.setErrors({});

      await schema.validate(data, {
        abortEarly: false,
      });
      if (data.valor === '') {
        data.valor = 0;
      }
      setLoading(true);
      await handleAdd(data);
      setLoading(false);
      handleClose();
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        const errors = getValidationErrors(err);
        formTableRef.current?.setErrors(errors);
      }
      setLoading(false);
    }
  }, []);

  const departamentosOptions = useMemo(() => {
    const options = departamentos.map((departamento: any) => {
      return {
        value: departamento.CodigoDepartamento,
        label: departamento.Nome,
      };
    });
    return options;
  }, [departamentos]);

  useEffect(() => {
    handleGetDepartamentos();
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        {loading ? (
          <TableLoader />
        ) : (
          <Form ref={formTableRef} onSubmit={handleSubmit}>
            <div style={{ display: 'none' }}>
              <Select
                name="departamento"
                label="Departamento"
                placeholder="Selecione o departamento"
                schema={schema}
                options={departamentosOptions}
              />
              <InputCurrency
                name="valor"
                label="Valor"
                schema={schema}
                defaultValue={0}
                placeholder="Digite o valor"
              />
            </div>
            Atenção! Preencha o valor da recarga correspondente a cada cartão
            e/ou funcionário e salve antes de preencher o próximo valor.
            <div className="buttonsContainer">
              <Button color="orange" padding="1" type="submit">
                Confirmar
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </Container>
  );
};

export default CreateOrderByValueModal;
